import * as React from 'react';
import { useEffect } from 'react';
import { Button } from 'reactstrap';
import { showErrorToastr, showSuccessToastr } from 'src/app/shared/helpers/toastr-helper/ToastrHelper';
import { fetchGet, fetchPost, getApiActionResult } from 'src/~api/ApiHelper';
import { GET_LICENSE_API_ROUTE, GET_LICENSE_USAGE_API_ROUTE, UPDATE_LICENSE_API_ROUTE } from '../~api/apiRoutes';

import './LicenseManage.css';
import { useTranslation } from 'react-i18next';
import { ILicenseUsage } from '../~store/models/LicenseUsage';
import LicenseDetails from './license-details/LicenseDetails';

const LicenseManage = () => {
    const { t } = useTranslation();
    const [licenseUsage, setLicenseUsage] = React.useState<ILicenseUsage | undefined>(undefined);
    const [licenseStr, setLicenseStr] = React.useState("");
    const [changedLicense, setChangedLicense] = React.useState("");

    useEffect(() => {
        _getLicenseFromServer();
        _getLicenseUsage();
    }, [])

    const _getLicenseFromServer = () => {
        fetchGet(GET_LICENSE_API_ROUTE)
        .then(function(response) {
            if(response.ok) {
                return response.text();
            }
            showErrorToastr(t('license.licenseErrorMessage'));
            return ""
        })  
        .then(function(text) { 
            setLicenseStr(text);
            setChangedLicense(text);
        })
        .catch(function() {
            showErrorToastr(t('license.licenseErrorMessage'));
        });
    }

    const _getLicenseUsage = async () => {
        const fetchPromise = fetchGet(GET_LICENSE_USAGE_API_ROUTE);
        const res = await getApiActionResult<ILicenseUsage>(fetchPromise, true);

        if (res.isSuccess)
        {
            setLicenseUsage(res.value);
        }
    }

    const _onSaveLicense = async (e: React.MouseEvent<any, MouseEvent>) => {
        const fetchPromise = fetchPost(UPDATE_LICENSE_API_ROUTE, {
            body: JSON.stringify({
                license: changedLicense
            })
        });
    
        const result = await getApiActionResult(fetchPromise, false);

        if(result.isSuccess) {
            _getLicenseUsage();
            showSuccessToastr(t('license.updateLicenseSuccessMessage'))
        }
        else {
            result.tryShowErrorToastr();
        }
    }

    return(
        <>
            <div className="license-manage-header">{t('license.license')}</div>
            <div className="license-manage-container">
                <div className="license-manage-container_license-lable">{t('license.licenseDetails') + ":"}</div>

                {licenseUsage && <LicenseDetails licenseUsage={licenseUsage} licenseXml={licenseStr}></LicenseDetails>}

                <div>
                    <textarea value={changedLicense} onChange={(e) => {setChangedLicense(e.currentTarget.value)}} className="license-manage-container_license" cols={30} rows={10} style={{resize: "none"}} />
                </div>
                <div>
                    <Button onClick={_onSaveLicense} disabled={licenseStr.localeCompare(changedLicense) === 0} className="license-manage-save">{t('common.save')}</Button>
                </div>
            </div>
        </>
    )
}

export default LicenseManage;